import { getTranslation } from '../utils/translation';
// import AppLocale from '../lang';

export const BET_SLIP_ERRORS = {
    singleMbnError: {
        type: 'error',
        key: 'SingleMbnError',
        message: getTranslation('betSlipErrorsSingleMbn'),
    },
    comboMbnError: {
        type: 'error',
        key: 'ComboMbnError',
        message: getTranslation('betSlipErrorsSingleMbn'),
    },
    combinationError: {
        type: 'warning',
        key: 'CombinationError',
        message: getTranslation('betSlipErrorsCombination'),
    },
    eventTypeCombinationError: {
        type: 'warning',
        key: 'EventTypeCombinationError',
        message: getTranslation('betSlipErrorsEventTypeCombination'),
    },
    mbnCombinationsError: {
        type: 'error',
        key: 'MbnCombinationError',
        message: getTranslation('betSlipErrorsMbnCombination'),
    },
    minimumStakeError: {
        type: 'error',
        key: 'MinimumStakeError',
        message: getTranslation('betSlipErrorsMinStake'),
    },
    maximumWinError: {
        type: 'error',
        key: 'MaximumWinError',
        message: getTranslation('betSlipErrorsMaxWin'),
    },
    maximumBetLineCountError: {
        type: 'error',
        key: 'MaximumBetLineCountError',
        message: getTranslation('betSlipErrorsMaxBetLine'),
    },
    oddChangeWarning: {
        type: 'warning',
        key: 'OddChangeWarning',
        message: getTranslation('betSlipErrorsOddChange'),
    },
    minimumOddError: {
        type: 'error',
        key: 'MinimumOddError',
        message: getTranslation('betSlipErrorsMinimumOdd'),
    },
    minimumTotalOddError: {
        type: 'error',
        key: 'MinimumTotalOddError',
        message: getTranslation('betSlipErrorsMinimumTotalOdd'),
    },
};
